<template>
  <div>
    <Breadcrumbs :classes="{ completed: true }" />
    <h3 class="text-menu px-3">下記の内容で予約を確定します</h3>
    <div class="px-3 font-hiraginoSans-w3" id="customerInfoBookingMobile">
      <div class="table-therapist">
        <div class="detail-info-customer">
          <div class="row row-plan-border-mobile py-1 check-box-timeprice mb-0 p-3 border-bottom-0-mobile font-family-W3">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <span>氏名</span>
            </div>
            <div class="w-40-mobile customer-info-mobile">
              <span>{{ customer.last_name }}</span>
              <span>{{ customer.first_name }}</span>
            </div>
          </div>
          <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <p>ふりがな</p>
            </div>
            <div class="w-40-mobile customer-info-mobile">
              <span>{{ customer.last_name_kana }}</span>
              <span>{{ customer.first_name_kana }}</span>
            </div>
          </div>
          <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <p>携帯電話番号</p>
            </div>
            <div class="customer-info-mobile">
              <span>{{ formattedTel }}</span>
            </div>
          </div>
          <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <p>メールアドレス</p>
            </div>
            <div class="customer-info-mobile">
              <span>{{ customer.email }}</span>
            </div>
          </div>
          <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <p>生年月日</p>
            </div>
            <div class="customer-info-mobile">
              <span>{{ formattedBirthDate }}</span>
            </div>
          </div>
          <div class="row row-plan-border-mobile py-1 mb-0 p-3 border-bottom-0-mobile">
            <div class="col-sm-2 p-0-mobile title-detail-customer-mobile">
              <p>性別</p>
            </div>
            <div class="customer-info-mobile">
              <span>{{ genderI18n }}</span>
            </div>
          </div>
        </div>
      </div>
      <BookingInfo/>
    </div>
    <div class="note-policy-cancel" v-if="clinicBasicSetting.cancellation_enabled && clinicBasicSetting.note_policy_cancel">
      <h3 class="text-menu">キャンセルポリシー</h3>
      <div class="policy-text">{{ clinicBasicSetting.note_policy_cancel }}</div>
    </div>
    <div class="footer-wrapper py-5">
      <div class="container">
        <div class="footer-buttons d-flex">
          <span id="backStepChooseTimeprice" class="back-step mr-2" @click="goBack">戻る</span>
          <span class="btn-choose-timeprice-option next-step text-center scroll-top" :class="{ 'disabled-submit': isSubmitting }" @click.prevent="completeBooking">予約決定する</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from './Breadcrumbs.vue';
import BookingInfo from './BookingInfo.vue';
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'CustomerInfo',
  components: {
    Breadcrumbs,
    BookingInfo
  },
  data() {
    return {
      isSubmitting: false
    };
  },
  computed: {
    ...mapGetters('permalink', ['selectedEvent', 'customerData', 'selectedTimeprice', 'selectedTherapist', 'selectedTimepriceOptions', 'currentCustomer', 'permalinkData']),
    clinicBasicSetting() {
      return this.permalinkData.clinic_basic_setting;
    },
    customer() {
      return this.currentCustomer && this.currentCustomer.id ? this.currentCustomer : this.customerData;
    },
    genderI18n() {
      switch (this.customer.gender) {
        case 'male':
          return '男性';
        case 'female':
          return '女性';
        case 'no_answer':
          return '回答しない';
        case 'other':
          return this.customer.gender_detail
          ? `その他：${this.customer.gender_detail}`
          : 'その他';
        default:
          return '';
      }
    },
    formattedBirthDate() {
      if (!this.customer.birth_date) return '';
      const date = new Date(this.customer.birth_date);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}年${month}月${day}日`;
    },
    formattedTel() {
      if (!this.customer.tel) return '';
      const tel = this.customer.tel.replace(/\D/g, '');
      return tel.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  },
  methods: {
    ...mapActions('permalink', ['createBooking', 'clearPasswordFields']),
    async completeBooking() {
      if (this.isSubmitting) {
        return;
      };
      this.isSubmitting = true;

      let params = {
        permalink: this.$route.params.permalink,
        customer: {
          email: this.customer?.email,
          password: this.customer?.password,
          last_name: this.customer?.last_name,
          first_name: this.customer?.first_name,
          last_name_kana: this.customer?.last_name_kana,
          first_name_kana: this.customer?.first_name_kana,
          tel: this.customer?.tel,
          birth_date: this.customer?.birth_date,
          gender: this.customer?.gender,
          gender_detail: this.customer?.gender_detail,
          password_confirmation: this.customer?.password_confirmation
        },
        room_booking: {
          time_start: this.selectedEvent?.startStr,
          time_end: this.selectedEvent?.endStr,
          timeprice_id: this.selectedTimeprice?.id,
          time_menu: this.selectedTimeprice?.id,
          therapist_id: this.selectedTherapist?.id || '',
          timeprice_option_ids: this.selectedTimepriceOptions.map(option => option.id),
        }
      }

      try {
        await this.createBooking(params);
      } finally {
        this.isSubmitting = false;
      }
    },
    goBack() {
      this.$emit('goBack');
      this.clearPasswordFields();
    }
  }
};
</script>

<style scoped>
.disabled-submit {
  pointer-events: none;
}
.note-policy-cancel {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.policy-text {
  border: 1px solid;
  border-radius: 4px;
  padding: 16px;
  white-space: pre-line;
  line-height: 16px;
  max-height: 150px;
  overflow-y: scroll;
}
</style>
